import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Project", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Bouwnummer", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Adres", -1)
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Opleverdatum", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Start Garantie", -1)

import { issueStore } from '@/stores/issue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowBuildingDetailsCard',
  setup(__props) {

const deliveryDate = computed(() => {
  if (issueStore().issue.building.delivery_date) {
    return new Date(issueStore().issue.building.delivery_date)
  }
  return null
})

const warrantyStartDate = computed(() => {
  if (deliveryDate.value) {
    const date = new Date(deliveryDate.value)
    date.setMonth(date.getMonth() + 3)
    return date
  }
  return null
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Bouwnummer",
    bordered: false
  }, {
    default: _withCtx(() => [
      (_unref(issueStore)().issue.project.name)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(issueStore)().issue.project.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(issueStore)().issue.building.number)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 1,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(issueStore)().issue.building.number), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(issueStore)().issue.building.address)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 2,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: 'https://www.google.com/maps/place/' + _unref(issueStore)().issue.building.address + ', ' + _unref(issueStore)().issue.building.zipcode + ' ' + _unref(issueStore)().issue.building.city,
                    target: "_blank"
                  }, _toDisplayString(_unref(issueStore)().issue.building.address) + ", " + _toDisplayString(_unref(issueStore)().issue.building.zipcode) + " " + _toDisplayString(_unref(issueStore)().issue.building.city), 9, _hoisted_4)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(issueStore)().issue.building.delivery_date)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 3,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(new Date(_unref(deliveryDate)).toLocaleDateString('nl-NL')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(issueStore)().issue.building.delivery_date)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 4,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(new Date(_unref(warrantyStartDate)).toLocaleDateString('nl-NL')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})